export default "__VITE_ASSET__tBF9GSmV__"